// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "AccountsRates__textCenter__nErc0";
export const table = "AccountsRates__table__75zS4";
export const tableInner = "AccountsRates__tableInner__4fl2i";
export const headerRow = "AccountsRates__headerRow__aLkvn";
export const white = "AccountsRates__white__xpCCq";
export const headerCell = "AccountsRates__headerCell__J9DYV";
export const responsiveTitle = "AccountsRates__responsiveTitle__Bcm0d";
export const responsiveTitleText = "AccountsRates__responsiveTitleText__CIfIR";
export const headerTitle = "AccountsRates__headerTitle__xtkm9";
export const sortingWrapper = "AccountsRates__sortingWrapper__Gra7+";
export const withHelpText = "AccountsRates__withHelpText__UhRth";
export const up = "AccountsRates__up__+C3DC";
export const down = "AccountsRates__down__a-Ev+";
export const body = "AccountsRates__body__gb5YI";
export const row = "AccountsRates__row__pXKCk";
export const cell = "AccountsRates__cell__f3796";
export const footer = "AccountsRates__footer__C9Uvn";
export const paginatorWrapper = "AccountsRates__paginatorWrapper__XNE+L";
export const pageSizeSelectorWrapper = "AccountsRates__pageSizeSelectorWrapper__fXVsI";
export const tooltipIconWrapper = "AccountsRates__tooltipIconWrapper__Xb-Uu";
export const debtsAccountDetails = "AccountsRates__debtsAccountDetails__BzL05";
export const creditAccountDetails = "AccountsRates__creditAccountDetails__2V4Kv";
export const accountsTable = "AccountsRates__accountsTable__jAv41";
export const pointing = "AccountsRates__pointing__4PULc";
export const accountRates = "AccountsRates__accountRates__G6V+r";
export const isMobile = "AccountsRates__isMobile__ATDMj";
export const tabs = "AccountsRates__tabs__vRWmi";
export const tabContent = "AccountsRates__tabContent__AWjAu";
export const accountSummary = "AccountsRates__accountSummary__Sq-W7";
export const categoryName = "AccountsRates__categoryName__I8cYK";
export const categoryCount = "AccountsRates__categoryCount__Bi73l";
export const opportunityCount = "AccountsRates__opportunityCount__mSVhb";
export const allRatesTable = "AccountsRates__allRatesTable__yvKQa";
export const tabbedRatesTable = "AccountsRates__tabbedRatesTable__p0ftO";
export const responsiveValueCell = "AccountsRates__responsiveValueCell__QSuLh";
export const hideForSmall = "AccountsRates__hideForSmall__Hihza";
export const opportunitiesCountWrapper = "AccountsRates__opportunitiesCountWrapper__iCp0a";
export const opportunitiesCountText = "AccountsRates__opportunitiesCountText__mwlG0";